import React, { useState, useEffect, useContext } from 'react';
import BasicContext from '../BasicContext';
import { Card } from 'antd-mobile';

import { UrlSearch } from "../../../utils/utils";

import * as Api from "../../../api/usms";
import { Purpose, ReceiptResult, ReceiptResultStyle } from '../utils/const';
import { renderDate, timeFormatType } from '../utils/timeFormat';
import { keyHasPermission, AclKeys } from '../utils/permissions';

import { Loading, Descriptions } from '../components';
import CompanyInfo from '../components/CompanyInfo';

import '../index.css';

export default function SendDetail(props) {

  const context = useContext(BasicContext);
  const permissions = context.permissions || [];

  const [sessionId, setSessionId] = useState();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    initData()
  }, [])

  const companyId = Number(UrlSearch("companyId"));

  const initData = () => {
    const id = UrlSearch("id");
    const sendtime = Number(UrlSearch("sendtime"));
    setSessionId(id);
    if (id && sendtime) {
      const data = {
        SessionId: id,
        BeginSendTime: sendtime,
        EndSendTime: sendtime + 600,// 结束时间剧开始时间10分钟
        IsIntact: keyHasPermission(AclKeys.SendRecordCompleteContent, permissions)
      }
      getInfo(data);
    }
  }

  const getInfo = (data) => {
    if (data.SessionId) {
      setLoading(true);
      Api.DescribeQueryRecord(data).then(res => {
        setList(res.Data || []);
        setLoading(false);
      }).catch(e => {
        setLoading(false);
        setErrorMessage(e.message || "获取数据失败")
      });
    }
  }

  // 发送明细
  const detailDescriptions = (detail) => [
    {
      label: "短信类型",
      value: Purpose[detail.Purpose]
    },
    {
      label: "国家/地区",
      value: detail.BrevityCode
    },
    {
      label: "发送字数",
      value: detail.ContentLength
    },
    {
      label: "拆分条数",
      value: detail.Cost
    },
    {
      label: "发送内容",
      value: detail.Content
    },
    {
      label: "运营商",
      value: detail.Carrier
    },
    {
      label: "SenderId",
      value: detail.SenderId
    },
    {
      label: "替换后SenderId",
      value: detail.ReplacedSenderId
    },
    {
      label: "替换后短信内容",
      value: detail.ReplacedContent
    },
  ]

  // 发送信息
  const sendDescriptions = (detail) => [
    {
      label: "手机号码",
      value: detail.Phone
    },
    {
      label: "发送状态",
      value: <span className={ReceiptResultStyle[detail.ReceiptResult]}>{ReceiptResult[detail.ReceiptResult]}</span>,
    },
    {
      label: "发送时间",
      value: renderDate(detail.SendTime * 1000, timeFormatType.time)
    },
    {
      label: "状态上报时间",
      value: detail.ReceiptTime ? renderDate(detail.ReceiptTime * 1000, timeFormatType.time) : ""
    },
  ]

  // 通道信息
  const channelDescriptions = (detail) => [
    {
      label: "通道名称",
      value: detail.ChannelId
    },
    // {
    //     label: "通道账号",
    //     value: channelInfo ? channelInfo.ChannelAccount : '-',
    // },
    {
      label: "回执状态码",
      value: detail.ReceiptCode
    },
    {
      label: "状态描述",
      value: detail.ReceiptDesc
    },
    {
      label: "解决方案",
      value: detail.InternalSolution
    },
  ]

  return (
    <div className="container">
      <h3 className='mb-10'>短信发送详情：{sessionId}</h3>
      <Loading loading={loading} error={errorMessage} >
        {list.map((info, index) => <div key={index}>
          <Card>
            <Card.Body>
              <CompanyInfo CompanyId={companyId} />
            </Card.Body>
          </Card>
          <Card style={{ marginTop: '10px' }}>
            <Card.Header title="发送明细" />
            <Card.Body>
              <Descriptions options={detailDescriptions(info)} />
            </Card.Body>
          </Card>
          <Card style={{ marginTop: '10px' }}>
            <Card.Header title="发送信息" />
            <Card.Body>
              <Descriptions options={sendDescriptions(info)} />
            </Card.Body>
          </Card>
          <Card style={{ marginTop: '10px' }}>
            <Card.Header title="通道信息" />
            <Card.Body>
              <Descriptions options={channelDescriptions(info)} />
            </Card.Body>
          </Card>
        </div>)}
      </Loading>
    </div>
  )
}
